import { SCRUB_STRING } from "@smartrr/shared/constants";
import { ICustomerRelationshipShallow } from "@smartrr/shared/entities/CustomerRelationship";

export const checkIsCustomerErased = (customer: ICustomerRelationshipShallow) =>
  customer.firstName === SCRUB_STRING;
